/// <reference types="vite-plugin-svgr/client" />

import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

import license from "@/assets/images/driverLicense.png";

import alertImg from "@/assets/images/alert.svg?react";

const list = [
  "Take a photo of your US-issued, valid, not expired ID",
  "Ensure that the image of your ID is not blurry.",
  "Position your ID flat, centered, and without any tilt.",
  "Use good lighting to avoid shadows or glare on the ID.",
  "All details on the ID (name, date of birth, ID number) must be clearly visible.",
];

const PhotoInstructionsBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => (
  <div className="flex flex-col justify-center">
    <p className="!m-0 section-title text-left">
      Driver’s License Upload Instructions
    </p>
    <p className="my-3 text-[17px] text-gray10 leading-[133%]">
      To verify your identity and qualify for treatment, please follow the
      guidelines below when uploading a photo of your driver's license
    </p>
    <img
      src={license}
      className=" mt-6 max-h-[221px] mx-auto"
      alt={"driver license"}
    />
    <div className="p-2.5 rounded-[10px] w-fit mx-auto bg-gray20/15 flex justify-center items-stretch mt-6 gap-2.5">
      <img
        src={alertImg as unknown as string}
        width={20}
        height={20}
        className="min-w-5"
        alt="alert"
      />
      <ul className="list-disc list-outside">
        {list.map((text, idx) => (
          <li
            className="text-black/80 ml-4 text-[13px] leading-[180%] font-roboto"
            key={idx}
          >
            {text}
          </li>
        ))}
      </ul>
    </div>

    <Button type={ButtonType.NEXT} onClick={() => setQuestionAnswer(true)} />
  </div>
);

export { PhotoInstructionsBanner };
